import { InventoryTranslations } from './zh';

export const inventoryEn: InventoryTranslations = {
  // Operation Types
  checkIn: 'Check In',
  checkOut: 'Check Out',
  inbound: 'Inbound',
  outbound: 'Outbound',
  adjust: 'Adjust',
  receiving: 'Receiving',
  return: 'Return',
  adjustment: 'Adjustment',
  transfer: 'Transfer',
  scrap: 'Scrap',
  
  // Operation Descriptions
  checkInDesc: 'Add parts to inventory at specified location',
  checkOutDesc: 'Take parts from inventory',
  receivingDesc: 'Receive shipment from supplier',
  returnDesc: 'Return parts to supplier',
  adjustmentDesc: 'Adjust inventory quantity',
  transferDesc: 'Transfer between locations',
  scrapDesc: 'Scrap unusable parts',
  
  // Form Fields
  selectStation: 'Please select a station',
  selectWarehouse: 'Please select a warehouse',
  quantity: 'Quantity',
  location: 'Location',
  reason: 'Reason',
  notes: 'Notes',
  operator: 'Operator',
  
  // Messages
  operationSuccess: 'Operation successful',
  operationFailed: 'Operation failed',
  invalidQuantity: 'Invalid quantity',
  insufficientStock: 'Insufficient stock',
  checkInFailed: 'Check in failed',
  checkOutFailed: 'Check out failed',
  reasonPlaceholder: 'e.g., Production use, Maintenance replacement, etc.',
  operations: 'Operations',
  recentOperations: 'Recent Operations',
  
  // Inventory View Page
  title: 'Inventory',
  logs: 'Operation Logs',
  stats: 'Statistics',
  operationType: 'Operation Type',
  
  // Statistics
  totalOperations: 'Total Operations',
  totalCheckIns: 'Total Check Ins',
  totalCheckOuts: 'Total Check Outs',
  totalAdjustments: 'Total Adjustments',
  
  // Scan Operations
  scanCode: 'Scan Barcode',
  scanPlaceholder: 'Scan or enter barcode',
  enterReason: 'Enter reason',
  invalidCode: 'Invalid code',
  checkInSuccess: 'Check in successful',
  checkOutSuccess: 'Check out successful',
  scrapSuccess: 'Scrap successful',
  transferDeveloping: 'Transfer feature is under development',
  unsupportedOperation: 'Unsupported operation type',
  
  // Other
  currentStock: 'Current Stock',
  afterOperation: 'After Operation',
  confirmOperation: 'Confirm Operation',
};

